import React from 'react';
import Canonical from './Canonical';
import Header from './home/Header';
import Hero from './home/Hero';
import Features from './home/Features';
import TeamSync from './home/TeamSync';
import ComparisonTable from './home/ComparisonTable';
import CTA from './home/CTA';
import Footer from './home/Footer';

const Home = () => {
    return (
        <>
        <Canonical path="/" />
        <div className="w-full min-h-screen bg-neutral-900">
            <Header />
            <Hero />
            <TeamSync />
            <Features />
            <ComparisonTable />
            <CTA />
            <Footer />
        </div>
        </>
    );
};

export default Home;
